import Maximize from '@/presentation/assets/svg/Maximize.svg'

interface MaximizeButtonProps {
  onClick: () => void
}

const MaximizeButton: React.FC<MaximizeButtonProps> = ({ onClick }) => (
  <img
    className="!absolute !right-6 !top-4 !z-10 !h-6 !w-6"
    src={Maximize}
    alt="Maximize icon"
    onClick={onClick}
  />
)

export default MaximizeButton
